<template>
    <div class="qzsy-table-container">
        <table class="qzsy-table">
            <thead>
                <tr>
                    <th class="col-xing">星</th>
                    <th class="col-su">宿</th>
                    <th class="col-shu">速</th>
                    <th class="col-gong">宫</th>
                    <th>殿</th>
                    <th>垣</th>
                    <th>庙</th>
                    <th>旺</th>
                    <th>乐</th>
                    <th>喜</th>
                    <th>管库星</th>
                    <th>化曜</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="index">
                    <td class="col-xing">{{ item.xing || '' }}</td>
                    <td class="col-su">{{ `${item.su1 || ''}${item.su || ''}${item.su2 || ''}` }}</td>
                    <td class="col-shu">{{ item.shu || '' }}</td>
                    <td class="col-gong">{{ `${item.gong1 || ''}${item.gong || ''}${item.gong2 || ''}` }}</td>
                    <td>{{ item.dian || '' }}</td>
                    <td>{{ item.yuan || '' }}</td>
                    <td>{{ item.miao || '' }}</td>
                    <td>{{ item.wang || '' }}</td>
                    <td>{{ item.le || '' }}</td>
                    <td>{{ item.xi || '' }}</td>
                    <td>{{ item.guan || '' }}</td>
                    <td>{{ item.hua || '' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    data: {
        type: Array,
        default: () => []
    }
})
</script>

<style scoped>
.qzsy-table-container {
    color: white;
    /* 全局白色字体 */
    overflow-x: auto;
    /* 添加横向滚动条 */
}

.qzsy-table {
    width: 100%;
    border-collapse: collapse;
    color: white;
    /* 表格文字白色 */
    font-size: 14px;
}

.qzsy-table th,
.qzsy-table td {
    padding: 10px 8px;
    border: 1px solid #444;
    text-align: center;
}

/* 前四列宽度设置 */
.col-xing {
    width: 80px;
    /* 星列宽度 */
    min-width: 80px;
}

.col-su {
    width: 100px;
    /* 宿列宽度 */
    min-width: 100px;
}

.col-shu {
    width: 80px;
    /* 速列宽度 */
    min-width: 80px;
}

.col-gong {
    width: 120px;
    /* 宫列宽度 */
    min-width: 120px;
}

/* 表头样式 */
.qzsy-table th {
    background-color: #33334d;
    font-weight: bold;
    color: #b0a0ff;
    /* 表头淡紫色 */
    position: sticky;
    top: 0;
}

/* 表格行样式 */
.qzsy-table tr:nth-child(even) {
    background-color: rgba(40, 40, 60, 0.5);
    /* 偶数行背景 */
}

.qzsy-table tr:nth-child(odd) {
    background-color: rgba(30, 30, 45, 0.5);
    /* 奇数行背景 */
}

.qzsy-table tr:hover {
    background-color: rgba(110, 90, 210, 0.2);
    /* 悬停效果 */
}
</style>